import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const detailsWrapper = css`
  block-size: unset;

  :last-child:not(:first-child) {
    flex-grow: 1;
  }
`

export const inputsWrapper = css`
  margin-inline-start: ${spacing(6)};
  margin-inline-end: ${spacing(1)};

  > *:last-child::before {
    /* Убираем лишние divider, которые были реализованы через ::before */
    content: none;
  }
`

export const inputColumns = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: ${spacing(1)};
`

export const suggest = css`
  margin-inline-start: ${spacing(1)};

  ::before {
    /* Убираем лишние divider, которые были реализованы через ::before */
    content: none;
  }
`

export const errorMessage = css`
  margin-block-start: ${spacing(0.5)};
`
/**
 * @todo – Тикет на доработку https://st.yandex-team.ru/CARGODEV-60588
 */
/** Насильно переопределяем gwc'шную высоту, тк очень криво сделаны отступы в мультилайн режиме */
export const multiline = css`
  & > div {
    padding-block: ${spacing(1)};
    min-block-size: auto;
  }
`
